import { render, staticRenderFns } from "./ConfigFormatsExogena.vue?vue&type=template&id=64779ac6&scoped=true"
import script from "./ConfigFormatsExogena.vue?vue&type=script&lang=js"
export * from "./ConfigFormatsExogena.vue?vue&type=script&lang=js"
import style0 from "./ConfigFormatsExogena.vue?vue&type=style&index=0&id=64779ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64779ac6",
  null
  
)

export default component.exports